// extracted by mini-css-extract-plugin
module.exports = {"title":"title-view_title__2hqfY","icon":"title-view_icon__C6xDc","container":"title-view_container__2ZIg7"};